<script setup>
import { usePage } from "@inertiajs/vue3";
import { computed, watch } from "vue";
import { toast } from "vue3-toastify";

const successFlash = computed(() => usePage().props.flash.success);

const errorFlash = computed(() => usePage().props.flash.error);

watch(successFlash, (value) => {
  if (value) {
    toast.success(value, { position: "top-right" });
  }
});

watch(errorFlash, (value) => {
  if (value) {
    toast.error(value, { position: "top-right" });
  }
});
</script>

<template></template>
